<mat-form-field class="bf-date-range-picker fbc-form-field" appearance="fill" floatLabel="auto" hideRequiredMarker="true">
  <mat-label [ngClass]="{'required': required}">{{'messages_center.quick_search.customDate' | translate }}</mat-label>
  <mat-date-range-input [formGroup]="formGroup" [rangePicker]="picker">
    <input matStartDate [formControlName]="startDateMapping" >
    <input matEndDate [formControlName]="endDateMapping" >
  </mat-date-range-input>
  <!--  <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>-->
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>

  @if (range.controls.start.hasError('matStartDateInvalid')) {
  <mat-error>Invalid start date</mat-error>
  }
  @if (range.controls.end.hasError('matEndDateInvalid')) {
  <mat-error>Invalid end date</mat-error>
  }
</mat-form-field>
